// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer2_footer__2qtYE"};